import { getHeadStylesSentinel } from "./headStylesSentinel";

export function appendLinkTagToHead(href: string): Promise<unknown> {
    let link = document.querySelector<HTMLLinkElement>(`link[href="${href}"]`);
    if (!link) {
        link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        // See the docstring in `headStylesSentinel.ts` for more details
        const sentinel = getHeadStylesSentinel();
        sentinel.before(link);
    }
    return new Promise<unknown>((resolve, reject) => {
        if (link.sheet) {
            resolve(undefined);
        } else {
            link.addEventListener("load", resolve);
            link.addEventListener("error", (event) => {
                reject(event.error);
            });
        }
    });
}
